import { OrderSearchFilter } from "./order-search-filter.model";

export class OrderSearchInputDto {
    filters: OrderSearchFilter[] = [];
    sort: string | null = null;
    pageNumber = 0;
    pageSize = 0;
}